<template>
  <div>
    <!-- 二次认领 -->
    <vxe-toolbar>
      <template v-slot:buttons>
        <!--  财务驳回财务审核通过，一次认领二次认领都需要可更改
        非代付情况：未生成收款单，或者收款单撤回（删除）可更改一次数据，二次认领随时可更改
        代付情况：财务审核通过可更改二次认领，不可更改一次认领，驳回不可更改二次认领，可更改一次认领，审批中二次认领，一次认领都不可更改
        代付情况下，还没有进行财务审核，二次认领的按钮不能点，一次认领可以
       -->
        <vxe-button
          :disabled="isDisabled"
          @click="insertRow()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('receivablesManage.button.add') }}</vxe-button
        >
        <vxe-button
          :disabled="isDisabled"
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('receivablesManage.button.delete') }}</vxe-button
        >
        <vxe-button
          v-if="isClaim"
          :disabled="isDisabled"
          @click="handleSave()"
          type="primary"
          icon="el-icon-files"
          class="vxe-btn-primary"
          >保存</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="column"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
      :valid-config="{ autoPos: true, message: 'inline' }"
      max-height="300px"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  // import dataBaseAPI from '@/api/dataBase';
  // import API from '@/api/capitalCenter/receivablesManage';
  export default {
    name: 'receivablesClaimInfo',
    props: [
      'contractCategory',
      'departmentList',
      'secondUnClaimAmountList', // 二次未认领金额
      'formData',
    ],
    components: {
      // SearchTable,
      // inputNumberAd,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      // 二次认领
      column() {
        return [
          // 海宁
          { type: 'checkbox', width: 50, fixed: 'left' },
          {
            // 序号
            type: 'seq',
            width: 90,
            title: this.$t('receivablesManage.receivablesClaimInfo.seq'),
            fixed: 'left',
          },
          {
            // 一次认领行项目号
            field: 'firstClaimId',
            width: 150,
            title: '一次认领行项目号',
            fixed: 'left',
            editRender: {
              name: 'ElSelect',
              options: this.firstClaimNoList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.chooseFirstClaimId },
            },
          },
          {
            // 客户
            field: 'customerName',
            title: this.$t('receivablesManage.receivablesClaimInfo.customerNo'),
            width: 150,
          },
          {
            // 收款类别
            field: 'receivedType',
            title: this.$t('receivablesManage.receivablesClaimInfo.receivedType'),
            width: 150,
            formatter: this.formatterReceivedType,
          },
          {
            // 部门
            field: 'claimDepartmentName',
            title: '部门',
            width: 150,
          },
          ...(this.contractCategory == 'sales'
            ? [
                {
                  // 销售管理号
                  field: 'salesOrderNo',
                  title: this.$t('receivablesManage.receivablesClaimInfo.salesOrderNo'),
                  width: 150,
                  editRender: { name: 'ElInput', props: { clearable: true } },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.salesOrderNo}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <search-table
                          searchType="contractHN"
                          isMultiple={true}
                          currentValue={row['salesOrderNo']}
                          checkRowKeys={[row['salesOrderNo']]}
                          extraData={{
                            customerNo: row.customerNo,
                            contractStatus: 'ZT03',
                            contractCategory: 'sales',
                            contractBusinessDepartment: row.claimDepartmentNo,
                            businessType: row.businessType,
                          }}
                          onInput={(val) => this.chooseTable(val, row, 'salesOrderNo')}
                        ></search-table>,
                      ];
                    },
                  },
                },
              ]
            : [
                {
                  // 采购管理号
                  field: 'purchaseOrderNo',
                  title: this.$t('receivablesManage.receivablesClaimInfo.purchaseOrderNo'),
                  width: 150,
                  editRender: { name: 'ElInput', props: { clearable: true } },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.purchaseOrderNo}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <search-table
                          searchType="contractHN"
                          isMultiple={true}
                          currentValue={row['purchaseOrderNo']}
                          checkRowKeys={[row['purchaseOrderNo']]}
                          extraData={{
                            supplierNo: row.customerNo,
                            contractStatus: 'ZT03',
                            contractCategory: 'purchase',
                            contractBusinessDepartment: row.claimDepartmentNo,
                          }}
                          onInput={(val) => this.chooseTable(val, row, 'purchaseOrderNo')}
                        ></search-table>,
                      ];
                    },
                  },
                },
              ]),
          {
            // 认领保证金金额
            field: 'originReceiveMarginAmount',
            title: '认领保证金金额',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.originReceiveMarginAmount)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.originReceiveMarginAmount}
                    max={999999999.999999}
                    min={0}
                    onChange={() => this.verifyAmount(row)}
                    onInput={(val) => this.chooseTable(val, row, 'originReceiveMarginAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 认领货款金额
            field: 'originReceiveGoodsAmount',
            title: '认领货款金额',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.originReceiveGoodsAmount)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.originReceiveGoodsAmount}
                    max={999999999.999999}
                    min={0}
                    onChange={() => this.verifyAmount(row)}
                    onInput={(val) => this.chooseTable(val, row, 'originReceiveGoodsAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 形式发票金额
            field: 'originProformaInvoiceAmount',
            title: this.$t('receivablesManage.receivablesClaimInfo.originProformaInvoiceAmount'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.originProformaInvoiceAmount)}
                  </span>,
                ];
              },
            },
          },
          {
            // 收款金额
            field: 'originReceiveMoneyAmount',
            title: this.$t('receivablesManage.receivablesClaimInfo.originReceiveMoneyAmount'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.originReceiveMoneyAmount)}</span>,
                ];
              },
            },
          },
          {
            // 国内银行扣费
            field: 'originDomesticBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.originDomesticBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.originDomesticBankDeductFee)}
                  </span>,
                ];
              },
            },
          },
          {
            // 国外银行扣费
            field: 'originForeignBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.originForeignBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.originForeignBankDeductFee)}
                  </span>,
                ];
              },
            },
          },
        ];
      },
      // 原币基准值名称(当一次认领存在形式发票金额时，以形式发票金额为准，若不存在时，以收款金额为准)
      amountName() {
        return this.formData.originProformaInvoiceAmount
          ? 'originProformaInvoiceAmount'
          : 'originReceiveMoneyAmount';
      },
      rules() {
        return {
          firstClaimId: [
            { required: true, message: '请选择一次认领行项目号', trigger: ['blur', 'change'] },
          ],
          ...(this.contractCategory == 'sales'
            ? {
                salesOrderNo: [
                  {
                    required: true,
                    message: this.$t('receivablesManage.placeholder.salesOrderNoPlaceholder'),
                    trigger: ['blur', 'change'],
                  },
                ],
              }
            : {
                purchaseOrderNo: [
                  {
                    required: true,
                    message: this.$t('receivablesManage.placeholder.purchaseOrderNoPlaceholder'),
                    trigger: ['blur', 'change'],
                  },
                ],
              }),
        };
      },
      isDisabled() {
        return (
          (this.formData.isAnotherPay == true || this.formData.isAnotherPay == 'Y') &&
          this.formData.financeAuditStatus != '002'
        );
      },
    },
    data() {
      return {
        isClaim: false,
        tableData: [], // 表格数据
        del: [],
        secondUnClaimAmount: {}, // 二次未认领金额
        addRowObj: {
          firstClaimId: null,
          businessType: null,
          customerNo: null,
          customerName: null,
          receivedType: null,
          claimDepartmentNo: null,
          claimDepartmentName: null,
          salesOrderNo: null,
          purchaseOrderNo: null,
          originReceiveMarginAmount: 0, // 认领保证金金额
          originReceiveGoodsAmount: 0, // 认领货款金额
          originProformaInvoiceAmount: 0,
          localProformaInvoiceAmount: 0,
          originReceiveMoneyAmount: 0,
          localReceiveMoneyAmount: 0,
          originDomesticBankDeductFee: 0,
          localDomesticBankDeductFee: 0,
          originForeignBankDeductFee: 0,
          localForeignBankDeductFee: 0,
        },
        firstClaimNoList: [], // 一次认领行项目列表
      };
    },
    mounted() {
      this.isClaim = this.$route.name == 'claim' ? true : false;
    },
    methods: {
      // 表格新增一行
      insertRow(row) {
        let record = { ...this.addRowObj };
        this.$refs.table.validate().then(() => {
          this.$refs.table.insertAt(record, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
          });
        });
      },
      // 表格删除
      handleDelete() {
        const selectedList = this.$refs.table.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.tips('noData', 'error');
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.del.push(item.id);
              }
            });
            this.$refs.table.removeSelecteds();
            this.tips('deleteSuccess', 'success');
          })
          .catch(() => {
            this.tips('cancelled', 'info');
          });
      },
      // 保存二次认领
      async handleSave() {
        // 需选择待拆分数据才能进行保存
        if (!this.formData.id) {
          return this.tips('onlyOneSelectData', 'error');
        }
        let departmentNos = [];
        if (this.departmentList.length > 0) {
          departmentNos = this.departmentList.map((item) => {
            return item.value;
          });
        }
        // 基本信息
        let params = {
          id: this.formData.id,
          departmentNos: departmentNos,
        };
        // 二次认领
        let secondClaimInfo = await this.exportChildData();
        if (secondClaimInfo) {
          params = {
            ...params,
            ...secondClaimInfo,
          };
          this.$emit('secondClaim', params);
        }
      },
      // 在值发生改变时更新数据
      updateData() {
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      filterTotalAmount(firstClaimId) {
        // 筛选总金额
        if (firstClaimId) {
          return this.secondUnClaimAmountList.find((item) => item.firstClaimId == firstClaimId);
        }
        return {};
      },
      // 一次认领赋值
      chooseTable(val, row, prop) {
        // 合同
        if (prop == 'salesOrderNo' || prop == 'purchaseOrderNo') {
          if (val && val.length > 0) {
            row[prop] = val[0].contractNo;
          } else {
            row[prop] = null;
          }
        }
        // 金额类
        if (prop.indexOf('Amount') != -1) {
          row[prop] = val ? val : 0;
          if (['originReceiveMarginAmount', 'originReceiveGoodsAmount'].indexOf(prop) != -1) {
            row[this.amountName] = this.$cal.calCommon(
              row.originReceiveMarginAmount,
              row.originReceiveGoodsAmount,
              '+',
              'amount'
            );
            if (this.amountName == 'originProformaInvoiceAmount') {
              // 形式发票金额
              row.localProformaInvoiceAmount = this.calcLocalAmount(
                row.originProformaInvoiceAmount
              );
              let returnAmountProps = [
                'originReceiveMoneyAmount',
                'originDomesticBankDeductFee',
                'originForeignBankDeductFee',
              ];
              returnAmountProps.map((item) => {
                row[item] = this.calcOriginAmount(
                  row.originProformaInvoiceAmount,
                  this.secondUnClaimAmount.originProformaInvoiceAmount,
                  this.secondUnClaimAmount[item]
                );
                row['local' + item.split('origin')[1]] = this.calcLocalAmount(row[item]);
              });
            } else {
              // 收款金额
              row.localReceiveMoneyAmount = this.calcLocalAmount(row.originReceiveMoneyAmount);
              let returnAmountProps = ['originDomesticBankDeductFee', 'originForeignBankDeductFee'];
              returnAmountProps.map((item) => {
                row[item] = this.calcOriginAmount(
                  row.originReceiveMoneyAmount,
                  this.secondUnClaimAmount.originReceiveMoneyAmount,
                  this.secondUnClaimAmount[item]
                );
                row['local' + item.split('origin')[1]] = this.calcLocalAmount(row[item]);
              });
            }
          }
        }
      },
      chooseFirstClaimId(val) {
        // 选择一次认领行项目号
        let item = val.row;
        if (item.firstClaimId) {
          if (item.firstClaimId != '-1') {
            Object.keys(this.addRowObj).map((it) => {
              if (it.indexOf('Amount') != -1 || it.indexOf('Fee') != -1) {
                item[it] = 0;
              } else if (it.indexOf('customer') == -1 && it != 'firstClaimId') {
                item[it] = this.firstClaimNoList.find((i) => i.value == item.firstClaimId)[it];
              }
            });
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: '该条一次认领尚未保存，请先保存再二次认领！',
            });
            this.clearRowInfo(val);
          }
        } else {
          this.clearRowInfo(val);
        }
      },
      clearRowInfo(val) {
        Object.keys(this.addRowObj).map((item) => {
          if (item.indexOf('Amount') != -1 || item.indexOf('Fee') != -1) {
            val.row[item] = 0;
          } else if (item.indexOf('customer') == -1) {
            val.row[item] = null;
          }
        });
      },
      // 计算原币
      calcOriginAmount(amountRow, totalAmountRow, returnTotalAmount) {
        // 当前行标识金额 * 最终所需返回金额的总额 / 标识金额总额
        let calcAmount1 = this.$cal.calCommon(amountRow, returnTotalAmount, '*');
        let calcAmount2 = this.$cal.calCommon(calcAmount1, totalAmountRow, '/', 'amount');
        return calcAmount2;
      },
      // 计算本币
      calcLocalAmount(originAmount) {
        return this.$cal.calCommon(originAmount, this.formData.exchangeRate, '*', 'amount');
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.table.getTableData().fullData;
        // 点击提交，走校验
        if (tableData.length == 0) {
          return {
            fundCollectionSecondClaimList: [],
            delFundCollectionSecondClaimList: this.del,
          };
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              let param = {
                fundCollectionSecondClaimList: tableData,
                delFundCollectionSecondClaimList: this.del,
              };
              resolve(param);
            });
          });
        }
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManage.message.${info}`),
          type: type,
        });
      },
      activeRowMethod({ row }) {
        this.secondUnClaimAmount = this.filterTotalAmount(row.firstClaimId);
        return !this.isDisabled;
      },
      formatterReceivedType({ cellValue }) {
        let options = this.$baseRequest.getDictListMapByType('receivedType');
        options.push({ label: '预收账款', value: 'RT17' });
        if (!options) return cellValue;
        let tempValue = options.find((it) => it.value == cellValue);
        if (tempValue != null) {
          return tempValue.label;
        } else {
          return cellValue || '';
        }
      },
    },
  };
</script>
